import { ReactComponent as CloseIcon } from "assets/svgs/Close.svg";
import FunctionalButton from "./FunctionalButton";
import { twMerge } from "tailwind-merge";

const DialogBox = ({
    description,
    subDescription = "",
    cancelButton,
    confirmButton,
    onClose = () => {},
    /** When true, skip fixed centering (for use inside AnimatedModal). */
    embedded = false,
    className = "",
}) => {
    return (
        <div
            className={twMerge(
                "relative flex h-fit w-100 flex-col items-center justify-center space-y-2 rounded-r10 bg-black100 px-9 py-6",
                !embedded &&
                    "fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2",
                className
            )}
        >
            <FunctionalButton
                icon={<CloseIcon />}
                className="absolute right-3 top-3"
                onClick={onClose}
            />
            <p className="h4l">{description}</p>
            <p className="text-h5 text-center text-black40">{subDescription}</p>
            <div className="flex w-full items-center justify-between">
                {cancelButton}
                {confirmButton}
            </div>
        </div>
    );
};

export default DialogBox;
